// modalStyles.ts - Export this constant and import it in your modal component

export const modalStyles = `
  .timetable-entry-modal {
    backdrop-filter: blur(4px);
    background-color: rgba(0, 0, 0, 0.25) !important;
    animation: maskFadeIn 0.35s ease;
  }
  
  .timetable-entry-modal.mask-closing {
    animation: maskFadeOut 0.4s ease !important;
  }
  
  @keyframes maskFadeIn {
    from {
      opacity: 0;
      background-color: rgba(0, 0, 0, 0);
    }
    to {
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
  
  @keyframes maskFadeOut {
    from {
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.25);
    }
    to {
      opacity: 0;
      background-color: rgba(0, 0, 0, 0);
    }
  }
  
  .timetable-entry-modal .p-dialog {
    animation: dialogOpen 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }
  
  .timetable-entry-modal .p-dialog.dialog-closing {
    animation: dialogClose 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  
  @keyframes dialogOpen {
    from {
      opacity: 0;
      transform: scale(0.92) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
  
  @keyframes dialogClose {
    from {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
    to {
      opacity: 0;
      transform: scale(0.88) translateY(25px);
    }
  }
  
  .field-section {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 16px;
    padding: 20px;
    border: 1px solid rgba(59, 130, 246, 0.1);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  }
  
  .section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.6);
  }
  
  .icon-circle {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 15px;
  }
  
  .section-header span {
    color: #1e3a8a;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
  
  .info-note {
    margin-top: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.3);
    color: #166534;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .entry-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    padding: 16px;
    border: 2px solid rgba(59, 130, 246, 0.2);
    position: relative;
    transition: all 0.2s ease;
  }
  
  .entry-card:hover {
    border-color: rgba(59, 130, 246, 0.4);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }
  
  .entry-number {
    position: absolute;
    top: -10px;
    left: 16px;
    background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
    color: white;
    font-weight: 700;
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
  
  .remove-button {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.3);
    border-radius: 8px;
    padding: 3px 6px;
    color: #dc2626;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  
  .remove-button:hover {
    background: rgba(239, 68, 68, 0.2);
    border-color: rgba(239, 68, 68, 0.5);
  }
  
  .add-entry-button {
    width: 100%;
    padding: 14px;
    background: rgba(59, 130, 246, 0.1);
    border: 2px dashed rgba(59, 130, 246, 0.4);
    border-radius: 12px;
    color: #1e40af;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .add-entry-button:hover {
    background: rgba(59, 130, 246, 0.15);
    border-color: rgba(59, 130, 246, 0.6);
  }
`;
